<div [class.is-invalid]="invalid" class="frequency-options">
    <button
        (click)="toggleFrequency(option.key)"
        *ngFor="let option of frequencyOptions"
        [attr.aria-pressed]="isFrequencySelected(option.key)"
        [class.frequency-option-selected]="isFrequencySelected(option.key)"
        [disabled]="readonly"
        class="frequency-option"
        type="button"
    >
        {{ option.labelKey | translate | uppercase }}
    </button>
</div>
